import { useCallback } from 'react'

import { CustomEvent } from '../../../enums/customEvent'
import { useCustomEventListener } from '../../../hooks/useCustomEventListener'
import { QuickStartStep } from '../enums/quickStartStep'
import { useQuickStartProgress } from './useQuickStartProgress'

// Billy orgs create invoices/quotes through the legacy Ember editors, which never go through
// useInvoiceEditorFormSubmit. Those editors dispatch these window events on save instead.
export const useMarkInvoiceStepDoneListener = () => {
  const { markStepDone } = useQuickStartProgress()

  const handleLegacyDocumentCreated = useCallback(() => markStepDone(QuickStartStep.Invoice), [markStepDone])

  useCustomEventListener(CustomEvent.InvoiceApproved, handleLegacyDocumentCreated)
  useCustomEventListener(CustomEvent.QuoteCreated, handleLegacyDocumentCreated)
}
